module.exports = __webpack_public_path__ + "static/integrations-teams-mobile-83ffe5bb05744ea37c90c6ee9ce546ee.png";